// extracted by mini-css-extract-plugin
export default {"info":"LabeledInput_info__2Siz+","error-message":"LabeledInput_error-message__zQwTI","children":"LabeledInput_children__MTCJE"};